// Preview des mockups pour validation user AVANT implémentation réelle
import React, { useState } from 'react';
import OrdersGridMockup from './OrdersGridMockup';
import DriverPlanningMockup from './DriverPlanningMockup';

/**
 * Cette page N'EST QU'UN APERÇU visuel des mockups design générés par
 * l'agent design_agent_full_stack. Les données sont HARDCODÉES pour montrer
 * le rendu final. Aucune logique métier n'est branchée.
 *
 * Une fois le design validé par l'utilisateur → implémentation réelle avec
 * données live depuis les APIs existantes.
 */
const RepartitionMockupPreviewPage = () => {
  const [page, setPage] = useState('orders'); // 'orders' | 'planning'

  const switchPage = () => setPage((p) => (p === 'orders' ? 'planning' : 'orders'));

  return (
    <>
      {/* Banner d'aperçu qui informe l'utilisateur */}
      <div className="bg-amber-500/90 text-black px-4 py-2 text-xs font-semibold text-center border-b-2 border-amber-600 sticky top-0 z-50">
        🎨 MOCKUP DESIGN — Données factices pour validation. Aucune logique branchée. Cliquez sur "Grille Commandes" / "Planning Chauffeurs" pour naviguer entre les 2 pages.
      </div>

      {page === 'orders' ? (
        <OrdersGridMockup onSwitchPage={switchPage} />
      ) : (
        <DriverPlanningMockup onSwitchPage={switchPage} />
      )}
    </>
  );
};

export default RepartitionMockupPreviewPage;
